// extracted by mini-css-extract-plugin
export default {"div":"TableRow_div__LQGSN"};